import { useEffect } from 'react';
import { onMessageListener } from '../../services/firebase';
import { notify } from '../../common/notificationService';
import { useNavigate } from 'react-router-dom';

export default function FCMListener() {
    const navigate = useNavigate();

    useEffect(() => {
            const unsubscribe = onMessageListener().then((payload: any) => {
              notify(
                payload.notification.title, 
                payload.notification.body, 
                "danger", 
                100000, 
                "http://localhost:3000/assets/audio/beep-warning.mp3", 
                "bottom-right",
                () => navigate('/')
              );
              console.log('payload', payload);
            });
        
            return () => {
              unsubscribe.catch(err => console.log('failed to unsubscribe: ', err));
            };
    });

    return null;
}
